<template>
  <ym-tabs v-if="navBarList.length"
           ref="tabs"
           size="medium"
           v-model="tabSelected"
           :sticky="tabSticky"
  >
    <!-- 导航栏 -->
    <ym-tab v-for="(item, index) in navBarList"
            :key="index"
            :name="item.type"
            :title="item.name"
    >
    </ym-tab>
    <!-- 导航栏标签 -->
    <div v-for="(item2, index2) in navBarList"
         :key="index2 + 4"
         :class="[
           'try-tag',
           `index${index2}`,
           { 'fixed': tabSticky },
           { 'hidden': !item2.hint },
         ]"
    >{{ item2.hint }}</div>
    <!-- 可滑动内容 -->
    <swiper ref="tabSwiper"
            :options="swiperOption"
    >
      <swiper-slide v-for="(item, index) in navBarList"
                    :key="index"
      >
        <!-- 简介 -->
        <template v-if="item.type === 'about' && introduction">
          <product-introduction ref="richTextComponent"
                                :class="{ 'about-container': introduction.about }"
                                :content="introduction.about"
                                :percent-grain-list="percentGrainList"
          />
          <div v-if="introduction.attachments && introduction.attachments.list.length"
               class="purchase-gift-container"
          >
            <div class="purchase-gift-title">
              <div class="purchase-gift-title-left">
                <span>{{ introduction.attachments.blockTitle }}</span>
                <ym-img class="tag"
                        :src="require('@/assets/img/course/tag_free.png')"
                />
              </div>
              <div class="purchase-gift-title-right">
                共{{ introduction.attachments.list.length }}门
              </div>
            </div>
            <div class="purchase-gift-list swiper-no-swiping">
              <div v-for="(item,index) in introduction.attachments.list"
                   :key="index"
                   class="purchase-gift-list-item"
                   @click="handleClickGiftItem(item.id, item.type)"
              >
                <div class="purchase-gift-list-item-top ym-two-line-ellipsis">
                  {{ item.title }}
                </div>
                <div class="purchase-gift-list-item-bottom live">
                  {{ item.type === 'course' ? '直播课' : '音频课' }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="introduction.comment && introduction.comment.list.length"
               class="class-notice-container"
          >
            <div class="class-notice-title">{{ introduction.comment.blockTitle }}</div>
            <review-item-new v-for="(item,index) in introduction.comment.list"
                             :key="index"
                             :item="item"
            />
          </div>
          <div v-if="introduction.notice && introduction.notice.list.length"
               class="class-notice-container"
          >
            <div class="class-notice-title">{{ introduction.notice.blockTitle }}</div>
            <div class="class-notice-list outer">
              <div v-for="(item, index) in introduction.notice.list"
                   :key="index"
                   class="class-notice-list-content"
              >
                {{ item.content }}
                <div v-for="(item2, index2) in item.list"
                     :key="index2"
                     class="class-notice-list"
                >
                  <div class="class-notice-list-content item2">
                    {{ item2.content }}
                  </div>
                  <div v-for="(item3, index3) in item2.list"
                       :key="index3"
                       class="class-notice-list"
                  >
                    <div class="class-notice-list-content item3">
                      {{ item3.content }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <router-link v-if="introduction.notice.showMore"
                         :to="{ name: 'CourseClassNotice', params: { id: product.id } }"
                         class="class-notice-btn"
            >
              <span>查看全部内容</span>
              <ym-icon name="right"
                       size="8"
                       color="#666"
              />
            </router-link>
          </div>
          <product-list :main-block="introduction.recommend ? [introduction.recommend] : []"
                        record-type="courseNew"
          />
        </template>
        <!-- 大纲 -->
        <template v-else-if="item.type === 'outline' && outline">
          <template v-if="isMember">
            <live-list v-if="outline.liveCourse && outline.liveCourse.length"
                       :list="outline.liveCourse"
                       :member="isMember"
                       :product="product"
                       :sell="sell"
                       :action-btn="actionBtn"
            />
            <product-introduction v-else
                                  :content="outline.about ? outline.about : ''"
            />
            <audition-list :list="outline.audition ? outline.audition : []" />
          </template>
          <template v-else>
            <audition-list :list="outline.audition ? outline.audition : []" />
            <live-list v-if="outline.liveCourse && outline.liveCourse.length"
                       :list="outline.liveCourse"
                       :member="isMember"
                       :product="product"
                       :sell="sell"
                       :action-btn="actionBtn"
            />
            <product-introduction v-else
                                  :content="outline.about ? outline.about : ''"
            />
          </template>
        </template>
        <!-- 挑战 -->
        <template v-else-if="item.type === 'challenge' && challenge">
          <challenge-list v-if="challenge.list && challenge.list.length && isMember"
                          :course-id="product.id"
                          :list="challenge.list"
          />
          <div v-else
               class="lesson-after-container"
               :class="[
                   { 'pt': !isMember },
                   { 'bg': challenge.commentList && challenge.commentList.length },
               ]"
          >
            <div v-if="isMember"
                 class="lesson-after-empty-member"
            >
              <ym-img class="icon"
                      :src="require('@/assets/img/course/empty_lesson_after.png')"
              />
              <span class="title">哈喽，欢迎加入</span>
              <div class="desc">
                我们将在<span>{{ challenge.startTime }}</span>开课，<br>期待你在课后作品里的优秀表现~
              </div>
            </div>
            <div v-else
                 class="lesson-after-empty"
            >
              <ym-img class="icon"
                      :src="require('@/assets/img/course/icon_lesson_after.png')"
              />
              <span>配套的课后练习与知识小结，加入课程查看~</span>
            </div>
            <div v-if="challenge.commentList && challenge.commentList.length"
                 class="lesson-after-comment"
            >
              <div class="lesson-after-comment-title">
                <ym-img class="icon"
                        :src="require('@/assets/img/course/icon_score_left.png')"
                />
                <span>往期学员作品及老师评价</span>
                <ym-img class="icon"
                        :src="require('@/assets/img/course/icon_score_right.png')"
                />
              </div>
              <div class="lesson-after-comment-list">
                <router-link v-for="(item,index) in challenge.commentList"
                             :key="index"
                             class="lesson-after-comment-list-item"
                             :to="{
                               name: 'WorkDetail',
                               params: { id: item.work.id },
                               query: { open: true }
                             }"
                >
                  <div class="lesson-title">{{ item.lessonTitle }}</div>
                  <div class="user-container">
                    <ym-avatar class="user-container-left"
                               :avatar="item.user.avatar"
                    />
                    <div class="user-container-right">
                      <div class="user-info">
                        <span>{{ item.user.name }}</span>
                        <ym-img v-if="item.showVip"
                                class="tag"
                                :src="require('@/assets/img/course/tag_fans.png')"
                        />
                        <ym-img v-if="item.showVip"
                                class="tag vip"
                                :src="require('@/assets/img/course/tag_vip.png')"
                        />
                      </div>
                      <div class="work-title">{{ item.work.title }}</div>
                      <div class="work-content ym-two-line-ellipsis">{{ item.work.content }}</div>
                    </div>
                  </div>
                  <div v-if="item.tutorReview"
                       class="tutor-container"
                  >
                    <ym-avatar class="tutor-container-left"
                               :avatar="item.tutorReview.tutor.avatar"
                    />
                    <div class="tutor-container-right">
                      <div class="user-name">{{ item.tutorReview.tutor.name }}</div>
                      <ym-score :score="item.tutorReview.score"></ym-score>
                      <div class="review-content ym-two-line-ellipsis">
                        {{ item.tutorReview.content }}
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </template>
        <!-- 评论 -->
        <template v-else-if="item.type === 'review' && comment">
          <div v-if="comment.count > 0"
               class="review-list-title"
          >
            <div class="review-list-title-left">全部评价（{{ comment.count }}）</div>
            <div class="review-list-title-right">
              <div class="review-list-title-right-item"
                   :class="{ 'active': commentType === 'hot' }"
                   @click="getCommentList('hot')"
              >热门</div>
              <div class="review-list-title-right-line"></div>
              <div class="review-list-title-right-item"
                   :class="{ 'active': commentType === 'new' }"
                   @click="getCommentList('new')"
              >最新</div>
            </div>
          </div>
          <review-list-new ref="reviewList"
                           :reviews="comment ? comment.list : []"
                           :next-start="comment.start"
                           :target-id="product.id"
                           :target-type="productType"
                           :show-bottom-bar="showBottomBar"
          />
        </template>
      </swiper-slide>
    </swiper>
  </ym-tabs>
</template>

<script>
  import { Tabs, Tab, Toast } from '@ymba/ym-ui';
  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import Avatar from '@/components/Avatar';
  import YmScore from '@/components/YmScore';
  import ProductList from '@/components/Product/BlockList';
  import ProductIntroduction from '@/components/RichText';
  import ReviewListNew from '@/pages/Review/components/ReviewListNew';
  import ReviewItemNew from '@/pages/Review/components/ReviewItemNew';
  import ChallengeList from '@/pages/Course/components/CourseDetailChallengeList';
  import AuditionList from '@/pages/Course/components/CourseDetailAuditionList';
  import LiveList from '@/pages/Course/components/CourseDetailLiveList';
  import pageScrollPercentMixin from '@/mixins/report/pageScrollPercent';
  import {
    getCourseIntroduction,
    getCourseOutline,
    getCourseChallenge,
    getCourseComment,
  } from '@/services/course';
  import { LIMIT } from '@/utils/constant';
  import { getProductPath, projectJump } from '@/utils';
  import validator from '@/utils/validator';

  export default {
    name: 'ProductDetailContent',
    mixins: [pageScrollPercentMixin],
    components: {
      'ym-avatar': Avatar,
      'ym-tabs': Tabs,
      'ym-tab': Tab,
      YmScore,
      swiper,
      swiperSlide,
      ProductIntroduction,
      ReviewListNew,
      ChallengeList,
      ProductList,
      ReviewItemNew,
      AuditionList,
      LiveList,
    },
    props: {
      value: [String, Number],
      navBarList: {
        type: Array,
        required: true,
        default() {
          return [];
        },
      },
      isMember: Boolean,
      productType: {
        type: String,
        required: true,
      },
      product: Object,
      sell: {
        type: Object,
        required: true,
      },
      showBottomBar: Boolean,
      actionBtn: {
        validator(val) {
          return validator.isObject(val);
        },
      },
    },
    data() {
      return {
        tabSelected: '',
        swiperOption: {
          loop: false,
          on: {
            slideChangeTransitionStart: this.onSlideChangeTransitionStart,
          },
          autoHeight: true,
          observer: true,
          observeParents: true,
        },
        tabTop: 0,
        tabSticky: false,
        introduction: null,
        outline: null,
        challenge: null,
        comment: null,
        commentType: 'new',
        scrollInitLoading: null,
      };
    },
    computed: {},
    watch: {
      value(val) {
        this.tabSelected = val;
      },
      tabSelected: {
        immediate: true,
        handler(val) {
          this.$emit('input', val);
          this.handleSwiperSlide(val);
          this.fetchData(val);
          this.scrollMonitor = val === 'about';
          if (val !== 'review' && this.$refs.reviewList) this.$refs.reviewList[0].removeScrollHandler();
        },
      },
      tabSticky(val) {
        this.$emit('sticky', val);
      },
    },
    methods: {
      controlScrollHandler() {
        Toast.allowMultiple = true;
        this.scrollInitLoading = Toast.loading({ duration: -1 });
        this.$nextTick(() => {
          if (this.$refs.tabs) {
            this.tabTop = this.$refs.tabs.$el.getBoundingClientRect().top;
          }
          setTimeout(() => {
            // eslint-disable-next-line max-len
            if (this.$refs.richTextComponent && this.$refs.richTextComponent[0].$el.getBoundingClientRect) {
              const rect = this.$refs.richTextComponent[0].$el.getBoundingClientRect();
              this.pageScrollHandler(rect);
            }
            if (this.scrollInitLoading) this.scrollInitLoading.clear();
          }, 1000);
        });
      },
      handleSwiperSlide(type) {
        this.$nextTick(() => {
          const index = this.navBarList.findIndex(item => item.type === type);
          this.$refs.tabSwiper.swiper.slideTo(index, 0);
        });
      },
      onSlideChangeTransitionStart() {
        this.tabSelected = this.navBarList[this.$refs.tabSwiper.swiper.activeIndex].type;
      },
      async fetchData(type) {
        const index = this.navBarList.findIndex(item => item.type === type);
        if (!this.navBarList[index] || (this.navBarList[index].loaded && type !== 'review')) return;
        switch (type) {
          case 'about':
            this.introduction = await getCourseIntroduction(this.product.id);
            break;
          case 'outline':
            this.outline = await getCourseOutline(this.product.id);
            break;
          case 'challenge':
            this.challenge = await getCourseChallenge(this.product.id);
            break;
          case 'review':
            if (!this.navBarList[index].loaded) await this.getCommentList();
            this.$refs.reviewList[0].controlScrollHandler(true);
            break;
          default:
            break;
        }
        this.navBarList[index].loaded = true;
      },
      async getCommentList(type) {
        if (type) this.commentType = type;
        this.comment = await getCourseComment({
          id: this.product.id,
          type: this.commentType,
          start: 0,
          limit: LIMIT,
        });
        await this.$nextTick();
        if (this.comment.list.length < LIMIT) {
          this.$refs.reviewList[0].stopData();
        } else {
          if (type) {
            this.$refs.reviewList[0].resetData();
            return;
          }
          this.$refs.reviewList[0].loading = false;
        }
      },
      handleClickGiftItem(id, type) {
        const route = getProductPath(type, id);
        projectJump(route);
      },
    },
    created() {
      this.controlScrollHandler();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .try-tag {
    position: absolute;
    top: 10px;
    height: 30px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 11px;
    border: 1px solid #ff7474;
    color: #ff0f0f;
    font-size: 18px;
    background-color: #fff2f2;
    z-index: 99;
    &.fixed {
      position: fixed;
    }
    &.hidden {
      display: none;
    }
    &.index0 {
      margin-left: 120px;
    }
    &.index1 {
      margin-left: 310px;
    }
    &.index2 {
      margin-left: 500px;
    }
    &.index3 {
      margin-left: 680px;
    }
  }

  .about-container {
    border-bottom: 11px solid #f4f4f4;
  }

  .purchase-gift {
    &-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 326px;
      background-color: #f3fbfc;
      border-bottom: 11px solid #f4f4f4;
    }
    &-title {
      padding: 50px 32px 32px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &-left {
        display: flex;
        align-items: center;
        span {
          color: @color-black-dark;
          font-size: @font-size-extra-large;
          font-weight: @font-weight-bold;
          line-height: 1;
        }
        .tag {
          width: 75px;
          height: 32px;
          margin-left: 12px;
        }
      }
      &-right {
        color: @color-black-dark;
        font-size: @font-size-base;
      }
    }
    &-list {
      display: flex;
      flex-wrap: nowrap;
      box-sizing: border-box;
      overflow-x: scroll;
      overflow-y: hidden;
      width: 100%;
      padding-left: 32px;
      padding-right: 12px;
      &-item {
        flex-shrink: 0;
        width: 300px;
        height: 154px;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 20px 20px 0;
        box-shadow: 0 0 20px 0 rgba(2, 204, 204, 0.1);
        display: flex;
        flex-direction: column;
        background-color: @color-white;
        margin-right: 20px;
        &-top {
          color: @color-black-dark;
          font-size: 26px;
          font-weight: @font-weight-bold;
          line-height: 36px;
        }
        &-bottom {
          width: 73px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 2px;
          color: @color-white;
          font-size: 20px;
          margin-top: 10px;
          &.live {
            background-color: #13b9bf;
          }
          &.audio {
            background-color: #fea500;
          }
        }
      }
    }
  }

  .class-notice {
    &-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      background-color: #ffffff;
      border-bottom: 11px solid #f4f4f4;
    }
    &-title {
      padding: 50px 32px 32px;
      box-sizing: border-box;
      color: @color-black-dark;
      font-size: @font-size-extra-large;
      font-weight: @font-weight-bold;
      line-height: 1;
    }
    &-list {
      &.outer {
        margin-bottom: 40px;
        padding: 0 30px;
      }
      &-content {
        color: @color-black-dark;
        font-size: 34px;
        font-weight: bold;
        margin-bottom: 10px;
        &.item2 {
          color: #666;
          font-size: 28px;
          padding-left: 15px;
        }
        &.item3 {
          color: #666;
          font-size: 24px;
          font-weight: normal;
          padding-left: 15px;
        }
      }
    }
    &-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666;
      font-size: 28px;
      width: 252px;
      height: 70px;
      border-radius: 18px;
      border: 1px solid #ccc;
      box-sizing: border-box;
      margin-left: 250px;
      margin-bottom: 50px;
      span:first-child {
        margin-right: 8px;
      }
    }
  }

  .lesson-after {
    &-container {
      &.pt {
        padding-top: 50px;
      }
      &.bg {
        background-color: #f5f6f7;
      }
    }
    &-empty {
      background-color: #fff;
      margin: 0 40px 40px;
      width: 670px;
      height: 80px;
      border-radius: 10px;
      border: 1px solid #abddde;
      display: flex;
      align-items: center;
      .icon {
        width: 84px;
        height: 80px;
      }
      span {
        color: #13b9bf;
        font-size: 28px;
        font-weight: bold;
        padding-left: 20px;
      }
    }
    &-empty-member {
      background-color: #fff;
      padding: 80px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .icon {
        width: 200px;
        height: 274px;
      }
      .title {
        color: #222;
        font-size: 36px;
        font-weight: bold;
        line-height: 1;
        margin: 30px 0 20px;
      }
      .desc {
        color: #666;
        font-size: 28px;
        text-align: center;
        span {
          color: #13b9bf;
        }
      }
    }
    &-comment {
      &-title {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 60px 0 40px;
        .icon {
          width: 34px;
          height: 20px;
          margin: 0 10px;
        }
        span {
          color: #222;
          font-size: 32px;
          font-weight: bold;
        }
      }
      &-list {
        padding-bottom: 40px;
        &-item {
          display: flex;
          flex-direction: column;
          width: 670px;
          border-radius: 16px;
          background-color: #fff;
          margin-left: 40px;
          padding: 50px 20px 20px;
          box-sizing: border-box;
          margin-bottom: 40px;
          &:last-child {
            margin-bottom: 0;
          }
          .lesson-title {
            color: #222;
            font-size: 32px;
            font-weight: bold;
            margin-bottom: 50px;
            display: flex;
            align-items: center;
            line-height: 1;
            &:before {
              flex-shrink: 0;
              content: '';
              width: 8px;
              height: 32px;
              display: block;
              border-radius: 2px;
              background: linear-gradient(360deg, #00BFD0 0%, #44DED8 100%);
              margin-left: 10px;
              margin-right: 20px;
            }
          }
          .user-container {
            display: flex;
            &-left {
              width: 70px;
              height: 70px;
              margin-right: 20px;
              flex-shrink: 0;
            }
            &-right {
              display: flex;
              flex-direction: column;
              .user-info {
                display: flex;
                align-items: center;
                span {
                  color: #222;
                  font-size: 28px;
                  font-weight: bold;
                }
                .tag {
                  width: 60px;
                  height: 28px;
                  margin-left: 10px;
                  &.vip {
                    width: 138px;
                  }
                }
              }
              .work-title {
                display: flex;
                align-items: center;
                height: 36px;
                margin-top: 20px;
                margin-bottom: 10px;
                background-color: #f5f6fa;
                border-radius: 4px;
                padding: 0 12px;
                color: #7a7a89;
                font-size: 24px;
                align-self: baseline;
              }
              .work-content {
                color: #222;
                font-size: 28px;
              }
            }
          }
          .tutor-container {
            display: flex;
            max-width: 630px;
            background-color: #F5F6F7;
            border-radius: 10px;
            margin-top: 30px;
            padding: 20px 20px 30px;
            &-left {
              width: 70px;
              height: 70px;
              margin-right: 16px;
              flex-shrink: 0;
            }
            &-right {
              display: flex;
              flex-direction: column;
              .user-name {
                color: #666;
                font-size: 26px;
                font-weight: bold;
                margin: 5px 0;
              }
              .review-content {
                color: #666;
                font-size: 26px;
                margin-top: 20px;
              }
            }
          }
        }
      }
    }
  }

  .review-list {
    &-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 40px 50px 0 40px;
      &-left {
        color: #222;
        font-size: 32px;
        font-weight: bold;
      }
      &-right {
        display: flex;
        align-items: center;
        &-item {
          color: #999;
          font-size: 26px;
          &.active {
            color: #222;
            font-weight: bold;
          }
        }
        &-line {
          width: 1px;
          height: 24px;
          margin: 0 22px;
          background-color: #ccc;
        }
      }
    }
  }

  /deep/ .ym-sticky {
    max-width: 750px;
  }
</style>
